// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const marcasFullfilledReducer = makeSetReducer(['marcas/fullfilled']);